// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608162207/js/" + chunkId + "." + {"44":"44d58fa2","225":"b8ba11ca","481":"58b76e5e","486":"574d4042","770":"dc11ec8d"}[chunkId] + ".0.1268409671699643.chunk.js";
};